<template>
  <div class="vx-col w-full">
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="เลือกวันเวลา">
          <label>เริ่มต้น: </label>
          <flat-pickr :config="configdateTimePicker" v-model="before_datetime" placeholder="Date Time" />
          <br>
          <br>
          <label> สิ้นสุด: </label>
          <flat-pickr :config="configdateTimePicker" v-model="after_datetime" placeholder="Date Time" />
          <br>
          <br>
          <div class="flex flex-wrap items-center">
            <vs-button color="primary" @click="selectdate_time ()">ค้นหา</vs-button>

            <div class="ml-auto flex items-center mt-2 sm:mt-0">
              <span class="mr-2 text-sm">รูปแบบการแสดงผล:</span>
              <vs-button
                size="small"
                icon-pack="feather"
                icon="icon-grid"
                :color="viewMode === 'card' ? 'primary' : 'dark'"
                :type="viewMode === 'card' ? 'filled' : 'border'"
                class="mr-1"
                @click="setViewMode('card')"
              >การ์ด</vs-button>
              <vs-button
                size="small"
                icon-pack="feather"
                icon="icon-list"
                :color="viewMode === 'table' ? 'primary' : 'dark'"
                :type="viewMode === 'table' ? 'filled' : 'border'"
                @click="setViewMode('table')"
              >ตาราง</vs-button>
            </div>
          </div>
        </vx-card>

      </div>


    </div>
    <br>
    <div v-if="viewMode === 'card'" class="vx-row">

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4" @click="$store.state.AppActiveUser.permissions.report.action ? activePrompt1=true : null">
        <statistics-card-line hideChart class="mb-base" icon="UsersIcon" icon-right :statistic="countuser.topup"
          statisticTitle="เติมเงิน / คน" color="success" />
      </div>
    </div>

    <vx-card v-else title="Active User (Table)">
      <vs-table stripe :data="tableRows">
        <template slot="thead">
          <vs-th>รายการ</vs-th>
          <vs-th>จำนวน Active User</vs-th>
          <vs-th></vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="(tr, i) in data" :key="i" :data="tr">
            <vs-td>
              <feather-icon icon="UsersIcon" svgClasses="h-4 w-4 mr-2 inline-block align-middle" />
              {{ tr.title }}
            </vs-td>
            <vs-td>{{ tr.statistic }}</vs-td>
            <vs-td>
              <vs-button
                size="small"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-download"
                :disabled="!$store.state.AppActiveUser.permissions.report.action"
                @click="activePrompt1 = true"
              >Export</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-prompt title="Active เติมเงิน" class="export-options" @cancle="clearFields"
      @accept="exportToExcel(activeuser.excel.topup,'Active เติมเงิน',headerVal)" accept-text="Export" @close="clearFields"
      :active.sync="activePrompt1">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>
  </div>

</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import axios from '../../axios'
import vSelect from 'vue-select'
import moment from 'moment'

export default {
  data () {
    return {
      before_datetime: moment.tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm'),
      after_datetime: moment.tz('Asia/Bangkok').add(1, 'days').format('YYYY-MM-DD HH:mm'),
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true
      },
      fileName: '',
      headerTitle: ['Username', 'เบอร์โทรศัพท์', 'LINE'],
      headerVal: ['topup_username', 'member_phone', 'member_line'],
      activeuser :
      {
        count : {},
        excel : {}
      },
      countuser: {
        topup: ''
      },
      data: [],
      activePrompt1: false,
      formats: ['xlsx', 'csv', 'txt'],
      selectedFormat: 'xlsx',
      cellAutoWidth: true,
      viewMode: 'card',
      viewModeStorageKey: 'reportActiveUserViewMode'


    }
  },
  computed: {
    tableRows () {
      return [
        {
          title: 'เติมเงิน / คน',
          statistic: this.countuser.topup
        }
      ]
    }
  },
  components: {
    flatPickr,
    StatisticsCardLine,
    vSelect
  },
  async mounted () {
    this.loadViewMode()
    await axios
      .get(`reportactiveuser/activeuser/${this.before_datetime }/${ this.after_datetime}`)
      .then(response => (this.activeuser.count = response.data))
    this.countuser.topup = this.activeuser.count.topupuser
    await axios
      .get(`reportactiveuser/dataactiveuser/${this.before_datetime }/${ this.after_datetime}`)
      .then(response => (this.activeuser.excel = response.data))

    this.fileName = `Report_Activeuser ${this.before_datetime} ${this.after_datetime}`
  },
  methods: {
    async selectdate_time () {
      await axios
        .get(`reportactiveuser/activeuser/${this.before_datetime }/${ this.after_datetime}`)
        .then(response => (this.activeuser.count = response.data))
      this.countuser.topup = this.activeuser.count.topupuser
      await axios
        .get(`reportactiveuser/dataactiveuser/${this.before_datetime }/${ this.after_datetime}`)
        .then(response => (this.activeuser.excel = response.data))
      this.fileName = `Report_Activeuser ${this.before_datetime} ${this.after_datetime}`
    },
    exportToExcel (count_data, name, headerVal) {
        import('@/vendor/Export2Excel').then(excel => {
          const list = count_data
          const data = this.formatJson(headerVal, list)
          excel.export_json_to_excel({
            header: this.headerTitle,
            data,
            filename: this.fileName,
            autoWidth: this.cellAutoWidth,
            bookType: this.selectedFormat
          })

          // Log the export action
          this.logExportAction(count_data, name)

          this.clearFields()
        })
    },
    async logExportAction (count_data, name) {
      try {
        const objectLogs = {
          username: '-',
          category: 'exportReport',
          type: 'activeUserReport',
          amount: count_data.length || 0,
          info: `ดาวโหลด report active user: ${name}`,
          admin: this.$store.state.AppActiveUser.admin_user,
          data: {
            before_datetime: this.before_datetime,
            after_datetime: this.after_datetime,
            filename: this.fileName,
            format: this.selectedFormat,
            record_count: count_data.length || 0,
            game_name: name
          }
        }
        
        await axios.post('/agent/log', objectLogs)
      } catch (error) {
        console.error('Failed to log export action:', error)
      }
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields () {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    },
    loadViewMode () {
      try {
        const saved = localStorage.getItem(this.viewModeStorageKey)
        if (saved === 'card' || saved === 'table') {
          this.viewMode = saved
        }
      } catch (e) {
        // ignore
      }
    },
    setViewMode (mode) {
      if (mode !== 'card' && mode !== 'table') return
      this.viewMode = mode
      try {
        localStorage.setItem(this.viewModeStorageKey, mode)
      } catch (e) {
        // ignore
      }
    }

  }
}

</script>

<style>

</style>
